import axios from 'axios';
// /** 系统配置接口  */
export const SYSTEM_SETTING = 'system/setting';

export const HOME = 'home';

/**
 * 获取业务首页英文版ID
 *
 * @export
 * @param {*} option homeConfigId首页ID
 * @returns Object
 */
export function enHomeConfigFun(option) {
    return axios.get('/system/home-config/findByParentId', { params: option });
}

/**
 * 获取业务首页信息, 拿里面ID拉取画布数据
 *
 * @export
 * @param {*} id homeConfigId首页ID
 * @returns Object
 */
export function homeConfigFun(id) {
    return axios.get(`/system/business-home-config/${id}`);
}

/**
 *获取画布json数据
 *
 * @export
 * @param {*} id
 * @returns containers为画布内容
 */
export function canvasApi(id) {
    return axios.get(`/canvas/canvas/${id}`);
}

/**
 * 首页大Banner广告
 * @param option
 * @returns {*}
 */
export function homeBannerApi(option, type) {
    return axios.get(`/system/home-advertisement${type ? '-cfg' : ''}`, { params: option });
}

/**
 * 首页个人面板组件2个按钮
 * @param option
 * @returns {*}
 */
export function personPanels(option) {
    return axios.get('/system/person-panel', { params: option });
}

/**
 *
 * @param option
 * @returns {*}
 */
export function tasksApi(option) {
    return axios.get('/human/task/find-my-unfinished', { params: option });
}

/**
 * 首页个人面板设置为提醒的任务数量
 * @param option
 * @returns {*}
 */
export function taskRemindApi(option) {
    return axios.get('/human/task/find-unfinlish-remind-count', { params: option });
}

/**
 * 首页个人信息组件接口
 * @param option
 * @returns {*}
 */
export function tasks(option) {
    return axios.get('/human/task/findMyTaskCalendar', { params: option });
}

/**
 * 首页个人面板学分，课时
 * @param option
 * @returns {*}
 */
export function creditHoursApi(option) {
    return axios.get('/system/credit/detail-hour-member', { params: option });
}

/**
 * 个人名片
 * @param option
 * @returns {*}
 */
export function gradeAPI(option) {
    return axios.get('/system/integral-result/other/grade', { params: option });
}

/**
 * 获取个人组织
 * @param option
 * @returns {*}
 */
export function detailApi(option) {
    return axios.get('/human/member/other/detail', { params: option });
}

/**
 * 获取个人组织
 * @param option
 * @returns {*}
 */
export function studyTimeApi(option) {
    return axios.get('/course-study/course-study-progress/other/history-and-now-duration', { params: option });
}

/**
 * 判断用户是否是专家 activeStatus， auditStatus 返回都是1的情况下是专家
 * @param option
 * @returns {*}
 */
export function otherSimpleApi(option) {
    return axios.get('/ask-bar/expert/other-simple', { params: option });
}

/**
 * 判断用户是否是讲师 如果返回是1就是讲师
 * @param option
 * @returns {*}
 */
export function lectureApi(option) {
    return axios.get('/training/lecturer/is-lecture-other', { params: option });
}

/**
 * 判断用户是否是班务 如果返回是1就是班务
 * @param option
 * @returns {*}
 */
export function teacherApi(option) {
    return axios.get('/training/class-teacher/other/is-teacher', { params: option });
}

/**
 * 获取讲师列表
 * @param option
 * @returns {*}
 */
export function lectureListApi(option, type) {
    return axios.get(`/training/home-lecturer${type ? '-cfg' : ''}`, { params: option });
}

/**
 * 获取新闻资讯列表
 * @param option
 * @returns {*}
 */
export function homeNewsApi(option, type) {
    return axios.get(`/system/home-news/business-home${type ? '-cfg' : ''}`, { params: option });
}

/**
 * 获取自定义列表
 * @param option
 * @returns {*}
 */
export function homecustomListApi(option, type) {
    return axios.get(`/system/home-content${type ? '-cfg' : ''}`, { params: option });
}

/**
 * 根据ids获取课程, 专题列表
 * @param option
 * @returns {*}
 */
export function findbyListApi(option) {
    return axios.get('/course-study/course-info/front/find-by-ids', { params: option });
}

/**
 * 根据ids获取直播列表
 * @param option
 * @returns {*}
 */
export function findgenseeListApi(option) {
    return axios.get('/course-study/gensee/front/find-by-ids', { params: option });
}

/**
 * 根据ids获取考试列表
 * @param option
 * @returns {*}
 */
export function findexamListApi(option) {
    return axios.get('/exam/exam/front/find-by-ids', { params: option });
}

/**
 * 根据ids获取调研列表
 * @param option
 * @returns {*}
 */
export function findresaListApi(option) {
    return axios.get('/exam/research-activity/front/find-by-ids', { params: option });
}

/**
 * 根据ids获取培训班列表
 * @param option
 * @returns {*}
 */
export function findstudentListApi(option) {
    return axios.get('/training/student/class-info/front/find-by-ids', { params: option });
}
/**
 * 根据ids获取外部活动列表
 * @param option
 * @returns {*}
 */
export function activityListApi(option) {
    return axios.get('/training/external-activity/list', { params: option });
}

/**
 * 课程最新列表
 * @param option
 * @returns {*}
 */
export function rankListApi(option) {
    return axios.get('/course-study/rank-study/cached', { params: option });
}

/**
 * 获取学分排行榜列表
 * @param option
 * @returns {*}
 */
export function xfrankListApi(option) {
    return axios.get('/system/credit/rank', { params: option });
}

/**
 * 获取热门知识排行榜列表
 * @param option
 * @returns {*}
 */
export function zsrankListApi(option) {
    return axios.get('/course-study/knowledge/rank-browse-count', { params: option });
}

/**
 * 获取热门话题排行榜列表
 * @param option
 * @returns {*}
 */
export function htrankListApi(option) {
    return axios.get('/system/topic/rank-watch', { params: option });
}

/**
 * 获取课程排行榜列表
 * @param option
 * @returns {*}
 */
export function kcrankListApi(option) {
    return axios.get('/course-study/course-total/course-finish-count', { params: option });
}

/**
 * 获取热门纷享排行榜列表
 * @param option
 * @returns {*}
 */
export function fxrankListApi(option) {
    return axios.get('/ask-bar/question/home-hot', { params: option });
}

/**
 * 获取课时排行榜列表
 * @param option
 * @returns {*}
 */
export function ksrankListApi(option) {
    return axios.get('/system/course-hour/rank', { params: option });
}

/**
 * 积分排行榜
 * @param option
 * @returns {*}
 */
export function integralRankApi(option) {
    return axios.get('/system/integral-result/rank-integral-total', { params: option });
}

/**
 * 时长排行榜
 * @param option
 * @returns {*}
 */
export function scrankListApi(option) {
    return axios.get('/course-study/course-total/course-study-time', { params: option });
}

/**
 * 猜你喜欢
 * @param option
 * @returns {*}
 */
export function cnListApi(option) {
    return axios.get('/course-study/course-info/front/recommend', { params: option });
}

/**
 * 获取用户所在的组织
 * @param option
 * @returns {*}
 */
export function findPathApi(id) {
    return axios.get(`/system/organization/find-path/${id}`);
}

/**
 * PC预览
 *
 * @export
 * @param {*} id
 * @returns
 */
export function moduleCfgApi(id) {
    return axios.get(`system/home-module-cfg?homeConfigId=${id}`);
}

/**
 * 时长排行榜判断当前人在第几名
 *
 * @export
 * @param {*} id
 * @returns
 */
export function getStudyTimeRankApi(id) {
    return axios.get(`course-study/course-study-progress/getStudyTimeRank?organizationId=${id}`);
}

/**
 * 积分排行榜判断当前人在第几名
 *
 * @export
 * @param {*} id
 * @returns
 */
export function getIntegralRankApi(id) {
    return axios.get(`system/integral-result/getIntegralRank?organizationId=${id}`);
}
